import { getQueryStringParamsFromStringUrl, logger } from '$utils'
import { defer } from 'react-router-dom'
import useAppStore, { isAppStateReady } from 'src/state/store'
import useStockStore from '../../store'
import { getDateRangeFromQueryStringOrAppStore } from 'src/components/common/helpers/queryString'
import { RangeFilter } from '$constants'
import dayjs from 'dayjs'

export default async function loader({ request }) {
  const queryParams = getQueryStringParamsFromStringUrl(request.url)

  logger.debug(
    '[loader] About to await AppState being ready in Received Invoices loader'
  )
  await isAppStateReady()
  logger.debug(
    '[loader] AppState should now be ready in Received Invoices loader'
  )

  const { start, end } = queryParams
  if (!start || !end) {
    // If there is no range in the query string then set the default range to
    // the current week
    useAppStore.getState().setDefaultReportsRange(dayjs(), RangeFilter.Week)
  }

  const { startDateTime, endDateTime } =
    getDateRangeFromQueryStringOrAppStore(queryParams)

  const getStockReceivedItems = useStockStore
    .getState()
    .getStockReceivedItemsAndStatements(startDateTime, endDateTime)

  return defer({
    data: Promise.all([getStockReceivedItems])
      .then(() => true)
      .catch((error) => {
        logger.error('Received Invoices Promise.all error', error)
        return false
      }),
  })
}
